import AppButton from 'src/components/base/Button/Button';
import { Typography } from '../Typography';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { changeMatchScoreState } from 'src/redux/services/questionnaireServices';
import { fetchQuestionnaireMetaData } from 'src/redux/actions/questionnaireActions';
import { clearModalContent } from 'src/redux/modules/modalEvent';
import { useTranslation } from 'react-i18next';

const MatchScoreDisclaimerModal = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const dispatch = useDispatch();
  const userId = useSelector(
    (state: any) => state?.questionnaireData?.initialMetadata?.user_id,
  );

  const { t } = useTranslation(
    'matchScoreConfirmationModal',
  );

  const startMatchScoreOnboarding = async () => {
    if (userId) {
      setLoading(true);
      await changeMatchScoreState(true, userId);
      await dispatch(fetchQuestionnaireMetaData(true, null, true));
      setLoading(false);
      dispatch(clearModalContent());
    }
  };

  return (
    <>
      <div className="match-score-modal-second ms-5 me-5">
        <div className=" font-weight mt-4 text-3">
          <Typography variant="size-20">{t('matchScoreDisclaimerModal.title')}</Typography>
        </div>
        <div className="mt-5 text-4">
          <Typography variant="size-16" color="color-4">
            {t('matchScoreDisclaimerModal.description')}
          </Typography>
        </div>
        <div className="mt-5 mb-4 d-flex justify-content-center">
          <AppButton
            label={t('matchScoreDisclaimerModal.buttonLabels.understand')}
            onClick={startMatchScoreOnboarding}
            textSize="size-16"
            className="modal-container__submit"
            isProcessing={loading}
            disabled={loading}
          />
        </div>
      </div>
    </>
  );
};

export default MatchScoreDisclaimerModal;
